module.exports = __webpack_public_path__ + "img/worgen-f-70.ae752c0c.gif";